import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import yup from '../../../common/utils/yup';
import { TextField, AutoComplete } from 'porosys-ui';
import { createPolicy, updatePolicy } from '../api';
import Form from '../../../common/ui/components/MainForm/MainForm';
import { getUsersList } from '../../User/api';
import '../styles.scss';

const validationSchema = yup.object({
    title: yup.string().required(),
    description: yup.string().required(),
    participants: yup.array().required().min(1, 'حداقل یک نفر باید حضور داشته باشد').nullable(true),
});

const PolicyForm = props => {
    const { meetingId, handleCancel, handleAddPolicy, handleUpdatePolicy, policyToEdit } = props;
    const [participants, setParticipants] = useState([]);
    const [shouldEditData, setShouldEditData] = useState(false);

    const inputValues = policyToEdit
        ? {
              _id: policyToEdit._id,
              title: policyToEdit.title,
              description: policyToEdit.description,
              participants: policyToEdit.participants
                  .filter(participant => participant && participant.fullname)
                  .map(participant => {
                      return { label: participant.fullname, value: participant._id };
                  }),
          }
        : {
              title: '',
              description: '',
              participants: [],
          };

    useEffect(() => {
        policyToEdit ? setShouldEditData(true) : setShouldEditData(false);
        const fetchParticipants = async () => {
            setParticipants(await getUsersList());
        };

        fetchParticipants();
    }, []);

    const { handleSubmit, values, handleChange, touched, errors, setFieldValue } = useFormik({
        initialValues: inputValues,
        onSubmit: values => {
            values.participants = values.participants.map(participant => participant.value);
            !shouldEditData
                ? createPolicy(meetingId, values).then(res => {
                      handleAddPolicy(res);
                  })
                : updatePolicy(meetingId, values).then(res => {
                      handleUpdatePolicy(res);
                  });
        },
        validationSchema,
    });

    const handleError = state => {
        if (touched[state] && errors[state]) return errors[state];
    };

    return (
        <div>
            <div>
                <Form
                    formTitle={policyToEdit ? `ویرایش تصمیم ${policyToEdit.title}` : `افزودن تصمیم جدید`}
                    handleCancel={handleCancel}
                    handleSubmit={handleSubmit}
                >
                    <TextField
                        classes={{ root: 'form-input' }}
                        value={values.title}
                        label={'عنوان'}
                        name="title"
                        placeholder="وارد کنید..."
                        onChange={handleChange('title')}
                        errorMessage={handleError('title')}
                    />
                    <TextField
                        classes={{ root: 'form-input' }}
                        value={values.description}
                        label={'توضیحات'}
                        name="description"
                        placeholder="وارد کنید..."
                        onChange={handleChange('description')}
                        errorMessage={handleError('description')}
                        multiline
                    />
                    <AutoComplete
                        selected={values.participants}
                        classes={{ input: 'form-input' }}
                        label="اعضای مربوطه"
                        multiple
                        onChange={(e, newValue) => {
                            setFieldValue('participants', newValue);
                        }}
                        options={participants.map(user => {
                            return { value: user._id, label: user.fullname };
                        })}
                        placeholder="انتخاب کنید..."
                        errorMessage={handleError('participants')}
                    />
                </Form>
            </div>
        </div>
    );
};

export default PolicyForm;
